import React, { useState, useEffect, useContext, useRef } from "react";
import { AppContext } from "../AppContextProvider";
import { WalletProviderContext } from "../walletprovider/WalletProvider";

import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalFooter,
  MDBModalBody,
  MDBModalHeader,
  MDBSelect,
  MDBInput,
  MDBBtn,
} from "mdb-react-ui-kit";
import { DwMpcWalletBackendProviderContext } from "../mpcwalletprovider/DwMpcWalletBackendProvider";

export default function MetafileModal(props) {
  const basicRef = useRef(null);
  const { selectedAccount } = useContext(WalletProviderContext);
  const { storageProps } = useContext(DwMpcWalletBackendProviderContext);
  const context = useContext(AppContext);
  const [isFiles, setIsFiles] = useState(false);
  const [files, setFiles] = useState([]);
  const [status, setStatus] = useState("");
  const [selectedPath, setSelectedPath] = useState();
  const [newPath, setNewPath] = useState("");
  const [folderList, setFolderList] = useState([]);
  const [isVisibility5, setIsVisibility5] = useState(false);
  const [processedGraph, setProcessedGraph] = useState(undefined);

  return (
    <>
      <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={props.visible} className="metafile-modal">
        <MDBModalDialog scrollable centered size="md">
          <MDBModalContent>
            <MDBModalHeader>
              <div className="title-text">{props.modalParam?.selectedNode.label}</div>
              <button
                type="button"
                className="button subtle medium"
                onClick={() => props.hideModal()}
                style={{ minWidth: "unset" }}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.70703 8L13.8535 2.85352C14.0488 2.6582 14.0488 2.3418 13.8535 2.14648C13.6582 1.95117 13.3418 1.95117 13.1465 2.14648L8 7.29297L2.85352 2.14648C2.6582 1.95117 2.3418 1.95117 2.14648 2.14648C1.95117 2.3418 1.95117 2.6582 2.14648 2.85352L7.29297 8L2.14648 13.1465C1.95117 13.3418 1.95117 13.6582 2.14648 13.8535C2.24414 13.9512 2.37207 14 2.5 14C2.62793 14 2.75586 13.9512 2.85352 13.8535L8 8.70703L13.1465 13.8535C13.2441 13.9512 13.3721 14 13.5 14C13.6279 14 13.7559 13.9512 13.8535 13.8535C14.0488 13.6582 14.0488 13.3418 13.8535 13.1465L8.70703 8Z"
                    fill="#D7DAE7"
                  />
                </svg>
              </button>
            </MDBModalHeader>
            <MDBModalBody>
              <div className="folder-info-div">
                {props.modalParam &&
                  Object.entries(props.modalParam?.metaArray[props.modalParam?.selectedNode.storageKey]).map(
                    ([k, n], l) => {
                      return (
                        <div className="pfad-text" key={l}>
                          {n !== undefined &&
                            n !== null &&
                            !k.includes("_type") &&
                            !k.includes("_created") &&
                            !k.includes("id") && (
                              <>
                                {k.toString().match(/[A-Z][a-z]+|[0-9]+/g) !== null ? (
                                  <>
                                    <span className="description-title">
                                      {k
                                        .toString()
                                        .match(/[A-Z][a-z]+|[0-9]+/g)
                                        .join(" ") + ": "}
                                    </span>
                                    <span className="description-detail">{n.toString().replace("_", " ")}</span>
                                  </>
                                ) : (
                                  <>
                                    <span className="description-title">{k + ": "}</span>
                                    <span className="description-detail">{n.toString().replace("_", " ")}</span>
                                  </>
                                )}
                              </>
                            )}
                        </div>
                      );
                    },
                  )}
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <div className="actions-button-div">
                <button className="button subtle medium " onClick={() => props.hideModal()}>
                  <span className="text">Close</span>
                </button>
              </div>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
